import type { CustomEventsContext } from '../types'

const TIMEOUT = 60 * 1000 // 60 minutes in ms

// data structure: { receipt: Base64 string | undefined, error: string | undefined }

export default function (this: CustomEventsContext, appleId: string, username: string) {
  return this.sendEventWithCallback(
    'subscription.buy.ios',
    {
      apple_id: appleId,
      username,
    },
    TIMEOUT
  ).then((data: unknown) => {
    const d = data as { receipt?: string; error?: string }
    if (d.receipt || d.error) {
      return data
    }
    return Promise.reject(
      new Error(this.ERROR_UNKNOWN)
    )
  })
}
